﻿import Rest from '@/rest'
import CacheService from '@/common/cache/CacheService'
import { Loading } from 'quasar'

class LookupService {
    GetLookupGroups() {
        return Rest.Get('/api/lookups/getlookupgroups');
    }

    GetNames() {
        return Rest.Get('/api/lookups/getnames');
    }

    GetLookup(name, id) {
        return Rest.Get(`/api/lookups/getlookup/${name}/${id}`);
    }

    GetLookups(name, inactive) {
        return Rest.Get(`/api/lookups/getlookups/${name}/${inactive}`);
    }

    Save(name, lookup) {
        return Rest.Post(`/api/lookups/save/${name}`, lookup);
    }

    Delete(name, id) {
        return Rest.Delete(`/api/lookups/delete/${name}/${id}`);
    }

    async Export(name) {
        try {
            Loading.show();
            var key = await Rest.Get(`/api/lookups/export/${name}`);
            CacheService.Download(key);
        } finally {
            Loading.hide();
        }
    }
}

export default new LookupService();